module.exports = __webpack_public_path__ + "cf.svg?e0c7df8026c2f123e1431764a1f53c6e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/cf.svg
// module id = 967
// module chunks = 27